function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.52173 10.0382C4.03595 10.1516 4.48203 10.2817 4.875 10.4299C7.0697 11.2575 7.60776 12.65 9.108 14.8676C9.80119 15.8923 12.7637 16.1269 14.8702 15.25C16.2044 14.6946 16.4138 12.9864 17.3942 12.25C18.2609 11.599 19.4109 11.5996 20.1767 11.6993C20.6716 11.7638 20.9938 12.2104 20.9847 12.7094L20.8968 17.5409C20.8745 18.7674 19.8739 19.75 18.6472 19.75H5.57519C4.97361 19.75 4.43173 19.3936 4.2121 18.8336C3.36845 16.6822 1.46441 11.4019 2.60377 10.232C2.80611 10.0243 3.10444 9.94613 3.52173 10.0382Z",
  fill: "#FA4364"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.71334 9.83637L15.394 11.1953L14.6518 15.3906C14.6237 15.5495 14.5344 15.6909 14.4038 15.7837C14.2731 15.8765 14.1116 15.9131 13.9549 15.8854L7.45586 14.7355C7.29916 14.7078 7.16006 14.618 7.06914 14.486C6.97823 14.354 6.94295 14.1906 6.97107 14.0316L7.71334 9.83637Z",
  stroke: "#131416",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.03132 8.03848L15.712 9.39742C15.8687 9.42514 16.0078 9.51487 16.0988 9.64687C16.1897 9.77887 16.2249 9.94233 16.1968 10.1013L16.0378 11.0003C16.0237 11.0797 15.9791 11.1504 15.9137 11.1968C15.8484 11.2432 15.7677 11.2615 15.6893 11.2477L7.4178 9.78418C7.33945 9.77031 7.2699 9.72545 7.22444 9.65945C7.17898 9.59345 7.16135 9.51172 7.17541 9.43225L7.33446 8.53326C7.36259 8.37431 7.4518 8.23289 7.58249 8.1401C7.71318 8.04731 7.87463 8.01075 8.03132 8.03848Z",
  stroke: "#131416",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1671 8.76966C13.4725 9.00061 15.0157 8.16688 15.25 6.84277",
  stroke: "#131416",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.25 6.84277C13.9447 6.61182 12.4014 7.44556 12.1671 8.76966",
  stroke: "#131416",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5763 8.66584C10.271 8.43489 9.10751 7.12225 9.34178 5.79815",
  stroke: "#131416",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.34178 5.79815C10.6471 6.0291 11.8106 7.34174 11.5763 8.66584",
  stroke: "#131416",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9853 8.5614L12.7578 8.875L11.5914 15.4675L9.81893 15.1539L10.9853 8.5614Z",
  stroke: "#131416",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0.71715 22.2134H5.66211V20.1911H3.98852C2.61358 20.1911 1.4298 19.1646 1.23497 17.8036L0.00724792 9.22492C-0.022234 9.01911 0.0391064 8.81055 0.175339 8.65363C0.311569 8.49652 0.509142 8.40625 0.71715 8.40625C4.53271 8.40625 7.67701 11.3352 8.01997 15.0629H14.6347C15.0003 14.1981 15.5866 13.4538 16.3517 12.8894C17.2619 12.2176 18.3409 11.8626 19.4722 11.8626H19.8265C20.2225 11.8626 20.5435 12.1837 20.5435 12.5798V17.4094C20.5435 18.9433 19.2956 20.1911 17.7619 20.1911H15.8525V22.2132H18.117C20.5701 22.2132 22.5657 20.2175 22.5657 17.7644C22.5657 17.3684 22.8869 17.0472 23.283 17.0472C23.6788 17.0472 24 17.3684 24 17.7644C24 21.0083 21.3609 23.6474 18.117 23.6474H0.71715C0.321091 23.6474 0.000106812 23.3265 0.000106812 22.9304C0.000106812 22.5343 0.321091 22.2134 0.71715 22.2134ZM19.1094 17.4096V13.3139C17.5779 13.4567 16.2821 14.4965 15.8208 15.9914C15.728 16.2921 15.4502 16.4972 15.1355 16.4972H7.33387C6.93781 16.4972 6.61664 16.176 6.61664 15.7799V15.74C6.61664 12.7706 4.4115 10.3065 1.55266 9.89948L2.65478 17.6004C2.74908 18.2597 3.32257 18.7569 3.98852 18.7569H17.7621C18.505 18.7569 19.1094 18.1524 19.1094 17.4096ZM14.4184 20.1911H7.09638V22.2134H14.4184V20.1911Z",
  fill: "#131416"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9679 8.00241C19.9654 7.80604 20.9614 7.45248 21.9514 7.46289",
  stroke: "#2C9358",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7359 5.61022C18.4307 5.04384 19.1221 4.53192 19.7681 3.91895",
  stroke: "#2C9358",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7503 3.63944C15.9595 3.27508 16.144 2.67691 16.5286 2.50586",
  stroke: "#2C9358",
  strokeWidth: 0.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgChristmasSleigh(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasSleigh);
export default __webpack_public_path__ + "static/media/christmas-sleigh.2b4dfdf1.svg";
export { ForwardRef as ReactComponent };